import { translate } from '../translate';

const getTimeUnitKey = (time: number) => {
  if (time <= 0) {
    return '0';
  }
  if (time === 1) {
    return '1';
  }
  return 'n';
};

export const getHotelFormatTimeTranslation = (days: number, hours: number, minutes: number) => {
  const dayKey = getTimeUnitKey(days);
  const hourKey = getTimeUnitKey(hours);
  const minuteKey = getTimeUnitKey(minutes);

  const timeKeys = days > 0 ? [dayKey, hourKey, 'x'] : [dayKey, hourKey, minuteKey];
  const timeKey = timeKeys.join('_');

  const translateContext = {
    day: days,
    number: days,
    hour: hours,
    hours,
    minute: minutes,
    minutes,
  };

  switch (timeKey) {
    case '1_0_x':
      return translate('ktxt_hotels_cross_sell_time_day', translateContext);
    case '1_1_x':
      return translate('ktxt_hotels_cross_sell_time_day_hour', translateContext);
    case '1_n_x':
      return translate('ktxt_hotels_cross_sell_time_day_hours', translateContext);
    case 'n_0_x':
      return translate('ktxt_hotels_cross_sell_time_days', translateContext);
    case 'n_1_x':
      return translate('ktxt_hotels_cross_sell_time_days_hour', translateContext);
    case 'n_n_x':
      return translate('ktxt_hotels_cross_sell_time_days_hours', translateContext);
    case '0_1_0':
      return translate('ktxt_hotels_cross_sell_time_hour', translateContext);
    case '0_1_1':
      return translate('ktxt_hotels_cross_sell_time_hour_minute', translateContext);
    case '0_1_n':
      return translate('ktxt_hotels_cross_sell_time_hour_minutes', translateContext);
    case '0_n_0':
      return translate('ktxt_hotels_cross_sell_time_hours', translateContext);
    case '0_n_1':
      return translate('ktxt_hotels_cross_sell_time_hours_minute', translateContext);
    case '0_n_n':
      return translate('ktxt_hotels_cross_sell_time_hours_minutes', translateContext);
    case '0_0_1':
      return translate('ktxt_hotels_cross_sell_time_minute', translateContext);
    case '0_0_n':
      return translate('ktxt_hotels_cross_sell_time_minutes', translateContext);
    default:
      return '';
  }
};
